module.exports = __webpack_public_path__ + "img/node-flexible-transparent.31a50b27.webp";